import { j as r, F as m } from "../../../../../emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import "@ionic/react";
import { x as p, C as u } from "../../../../../FeatureFlagProvider-DSFeeZ8R.js";
import "react";
import "../../../../../react-paginate-Lh5zQzpz.js";
import { SwingHeroInEligible as a } from "./SwingHeroInEligible/SwingHeroInEligible.js";
import "../../../LoadingInterstitial/LoadingInterstitial.js";
import "../../../../contexts/DesignSystemProvider/DesignSystemProvider.js";
function k(t) {
  const {
    subDaysWorked: o,
    score: s,
    isSwingHero: l,
    isHourly: e,
    onClick: i,
    isSwingHeroEligible: n
  } = t, g = o < 5 || s === void 0;
  return /* @__PURE__ */ r(m, {
    children: n === !1 ? /* @__PURE__ */ r(a, {
      isHourly: e,
      onClick: i == null ? void 0 : i.skillBuilderOnClick
    }) : g ? /* @__PURE__ */ r(p, {
      subDaysWorked: o,
      isHourly: e,
      onClick: i == null ? void 0 : i.requestsOnClick
    }) : /* @__PURE__ */ r(u, {
      score: s,
      isSwingHero: l,
      isHourly: e,
      onClick: i == null ? void 0 : i.requestsOnClick
    })
  });
}
export {
  k as SwingHero
};
